export const turnOffArtBoardClipPath = (self) => {
  const working_layer_el = self._getWorkingLayerElThrowable();
  working_layer_el.removeAttributeNS(null, "clip-path");
};
